import { render, staticRenderFns } from "./ServiceRequestTypesAndSLAConfigurations.vue?vue&type=template&id=5b7e631e&scoped=true&"
import script from "./ServiceRequestTypesAndSLAConfigurations.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestTypesAndSLAConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e631e",
  null
  
)

export default component.exports